import { ROLE_STATUS, ROLE_VALUES, ROLES } from "./constants";

const INDIA_MOBILE_RE = /^(?:\+91[-\s]?|0)?[6-9]\d{9}$/;
const IFSC_RE = /^[A-Z]{4}0[A-Z0-9]{6}$/;
const ACCOUNT_NUMBER_RE = /^\d{9,18}$/;

export const DEFAULT_NOTIFICATION_PREFERENCES = Object.freeze({
  applicationUpdates: true,
  newRoles: true,
  recruiterMessages: true,
  documentRequests: true,
  interviewChanges: true,
  weeklyDigest: false,
});

export const DEFAULT_UI_PREFERENCES = Object.freeze({
  theme: "light",
});

export function isCanonicalRole(role) {
  return ROLE_VALUES.includes(role);
}

export function resolveRoleDocument(data) {
  if (!data || !data.role) {
    return {
      role: null,
      status: ROLE_STATUS.UNKNOWN,
      message: "Your account role is not configured yet.",
    };
  }

  if (!isCanonicalRole(data.role)) {
    return {
      role: null,
      status: ROLE_STATUS.UNKNOWN,
      message: "Your account role is not recognized.",
    };
  }

  if (data.status === "inactive" || data.disabled === true) {
    return {
      role: null,
      status: ROLE_STATUS.ERROR,
      message: "Your account is inactive. Contact hr@saturnmax.com.",
    };
  }

  return {
    role: data.role,
    status: ROLE_STATUS.READY,
    message: "",
  };
}

export function buildSafeCandidateUserData(existingData = null, nextData = {}) {
  const existing = existingData || {};
  const email = nextData.email || existing.email || "";
  const fallbackName = email ? email.split("@")[0] : "Candidate";

  return {
    role: existing.role || ROLES.CANDIDATE,
    email,
    name: nextData.name || existing.name || fallbackName,
    status: existing.status || "active",
  };
}

export function canUseCandidateWorkflow(role) {
  return role === ROLES.CANDIDATE;
}

export function isValidIndianMobile(value) {
  return INDIA_MOBILE_RE.test(String(value || "").trim());
}

export function isValidIfsc(value) {
  return IFSC_RE.test(String(value || "").trim().toUpperCase());
}

export function isValidAccountNumber(value) {
  return ACCOUNT_NUMBER_RE.test(String(value || "").trim());
}

export function normalizeUserPreferences(data = {}) {
  const notificationPreferences = data.notificationPreferences || {};
  const uiPreferences = data.uiPreferences || {};
  const theme = ["light", "dark", "system"].includes(uiPreferences.theme)
    ? uiPreferences.theme
    : DEFAULT_UI_PREFERENCES.theme;

  return {
    notificationPreferences: {
      ...DEFAULT_NOTIFICATION_PREFERENCES,
      ...Object.keys(DEFAULT_NOTIFICATION_PREFERENCES).reduce((acc, key) => {
        if (typeof notificationPreferences[key] === "boolean") {
          acc[key] = notificationPreferences[key];
        }
        return acc;
      }, {}),
    },
    uiPreferences: {
      ...DEFAULT_UI_PREFERENCES,
      theme,
    },
  };
}

export function buildUserPreferencesUpdate(existingData = {}, nextData = {}) {
  const current = normalizeUserPreferences(existingData);
  const incoming = normalizeUserPreferences({
    notificationPreferences: {
      ...current.notificationPreferences,
      ...(nextData.notificationPreferences || {}),
    },
    uiPreferences: {
      ...current.uiPreferences,
      ...(nextData.uiPreferences || {}),
    },
  });

  return {
    notificationPreferences: incoming.notificationPreferences,
    uiPreferences: incoming.uiPreferences,
  };
}
